import { Pipe, PipeTransform } from '@angular/core';
import { Therapies } from 'src/app/shared/models/therapy';

@Pipe({
  name: 'therapyIcon',
})
export class TherapyIcon2Pipe implements PipeTransform {
  transform(value: any) {
    const retVal = Therapies.therapyItems.find(therapyItem => therapyItem.id === Number(value));
    if (retVal) {
      return retVal.iconName;
    }
  }
}
